var lx = lx || {};
lx.item = lx.item || {};
lx.region = lx.region || {};

lx.item.getChbxVal = function (pId, pType, pElement) {
    var count = 0;
    var path, vElement, vRet;
    if (pElement == undefined) {
        vElement = '';
    } else {
        vElement = pElement;
    }
    if (pType == 'H') {
        path = '#' + pId + " " + vElement;
    }
    if (pType == 'V') {
        path = '#' + pId;
    }
    $(path).find('input[type="radio"]').each(function () {
        if ($.trim($(this).val()).length) {
            if ($('input[id="' + pId + '_' + count + '"]:checked').val() !== undefined) {
                vRet = $('input[id="' + pId + '_' + count + '"]:checked').val();
            }
            count += 1
        }
    });

    return vRet;
};

lx.item.getSwitchVal = function (pId) {
    if ($('input[id="' + pId + '_Y"]:checked').val() !== undefined) {
		return $('input[id="' + pId + '_Y"]:checked').val();
	}
	else {
		return $('input[id="' + pId + '_N"]:checked').val();
	}
};

lx.item.getSliderVal = function (pId) {
    if ($('input[id="' + pId + '"]:checked').val() !== undefined) {
		return 'Y';
	}
	else {
		return 'N';
	}
};

lx.item.getRadioVal = function (pId) {
    if ($('input[id="' + pId + '_0"]:checked').val() !== undefined) {
		return 'Y';
	}
	else {
		return 'N';
	}
};

lx.item.refresh_item = function (pPage) {
    var missCerts = [82, 124];
    if (missCerts.indexOf(pPage) != -1) {
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=checkRequiredCertificates",
                x01: $v('P' + pPage + '_WP_ID'),
                x02: $v('P' + pPage + '_PROFILE_ID')
            },
            success: function (d) {
                if (d == '') {
                    // alert("nema");
                    $("#missCerts").hide();
                    $('#P' + pPage + '_WP_ID_A').css({
                        "color": '#494949'
                    });
                    $('#P' + pPage + '_WP_ID_A').css({
                        "font-weight": 'normal'
                    });
                    $('#P' + pPage + '_WP_ID_IMG').remove();
                } else {
                    //alert("ima");
                    $('#missCerts').removeAttr("style");
                    $('#missCerts').html(d);
                    $('#P' + pPage + '_WP_ID_A').css({
                        "color": '#dd7676'
                    });
                    $('#P' + pPage + '_WP_ID_A').css({
                        "font-weight": 'bold'
                    });
                    $('#P' + pPage + '_WP_ID_IMG').remove();
                    $('#P' + pPage + '_WP_ID_POST').prepend('<img id="P' + pPage + '_WP_ID_IMG" style="vertical-align:middle;padding-left:4px" src="/i/social/img/misc/alarm.png" />');
                }
            }
        });
    }
};

/* Generate Item Html
Moved from multirow.js by Davor on 31.10.2019
*/
lx.item.gen = function (params) {
    var vRet = "", vTemp, vHidden = "", vData = false, vValue, vWidth, wrapperType = ' apex-item-wrapper--text-field';
    if (params.data) vData = true;
    vTemp = "";
    // set item value
    if (vData) vValue = params.data.r;
    else vValue = params.item.def;
    // set item width if specified
    if (params.item.width) vWidth = 'width:' + params.item.width; //+ 'px;'
    else vWidth = '';
    // generate item based on his type
    switch (params.item.type) {
        // Hidden item
        case "H": vHidden += '<input type="hidden" id="' + params.id + '" value="' + vValue + '" />';
            break;
        // Number item
        case "N": vTemp = '<input type="text" id="' + params.id + '" value="' + vValue + '" style="text-align:right;' + vWidth + '" />';
            break;
        // Text item
        case "T": vTemp = '<input type="text" id="' + params.id + '" value="' + vValue + '"' + (vWidth ? ' style="' + vWidth + '"' : '') + ' />';
            break;
        // Text area item
        case "TA": vTemp = '<textarea rows="1" id="' + params.id + '" style="height:20px;' + vWidth
            + '">' + vValue + '</textarea>';
            break;
        // Date Item
        case "D": vTemp = '<input type="text" id="' + params.id + '" value="' + vValue + '" class="lxpMrDate" />';
            // todo add datepicker js
            break;
        // Display value, saves item state
        case "DS": vTemp += vValue + '<input type="hidden" id="' + params.id + '" value="' + vValue + '" />';
            break;
        // Display value only
        case "DO": vTemp += vValue + '<input type="hidden" id="' + params.id + '" value="' + vValue + '" />';
            break;
        // Select item
        case "S": var vSelected = false;
            for (var o = 0; o < params.item.options.length; o++) {
                if (vValue == params.item.options[o].r) {
                    vSelected = true;
                    vTemp += '<option value="' + params.item.options[o].r + '" selected >'
                        + params.item.options[o].d + '</option>';
                } else vTemp += '<option value="' + params.item.options[o].r + '">'
                    + params.item.options[o].d + '</option>';
            }
            if (vData && typeof vValue != 'undefined' && !vSelected) vTemp += '<option value="' + vValue + '" selected>' + params.data.d + '</option>';

            if (params.item.feat == "PROF_PIC") vTemp = '<div class="lxpMrPic"><img src="LINXPOT.multimedia.thumb?p_id='
                + (vData ? params.data.r : params.item.def)
                + '&p_maxscale=45 45&p_type=PROFILE" /></div><select name="' + params.id
                + '" ' + (vWidth ? ' style="' + vWidth + '"' : '') + ' onchange="multirowForm.featSelect(this);">'
                + vTemp + '</select>';
            else vTemp = '<select class="selectlist apex-item-select" id="' + params.id + '"' + (vWidth ? ' style="' + vWidth + '"' : '') + ' size="1">' + vTemp
                + '</select>';//lxpMrSelect
            wrapperType = ' apex-item-wrapper--select-list';
            break;
        // Checkbox item
        case "C": var vValueArr = vValue.split(":"), vChecked;
            for (var i = 0; i < params.item.options.length; i++) {
                vChecked = '';
                for (var j = 0; j < vValueArr.length; j++) {
                    if (vValueArr[j] == params.item.options[i].r) vChecked = ' checked="checked"';
                }
                vTemp += '<div class="apex-item-option"><input id="' + params.id + '_' + i + '" type="checkbox" name="' + params.id + '" value="' + params.item.options[i].r
                + '"' + vChecked + '>' + '<label style="font-size: 12px;" for="' + params.id + '_' + i + '">' + params.item.options[i].d + '</label></div>';
            }
            wrapperType = 'apex-item-wrapper--radiogroup t-Form-fieldContainer--radioButtonGroup t-Form-fieldContainer--stretchInputs';
            vTemp = /*'<div id="' + params.id + '_CONTAINER" class="lxFormChk t-Form-fieldContainer apex-item-wrapper apex-item-wrapper--radiogroup t-Form-fieldContainer--radioButtonGroup t-Form-fieldContainer--stretchInputs">' + 
                    '<div class="t-Form-inputContainer"><div class="t-Form-itemWrapper">'+*/
                    '<div id="' + params.id + '" class="checkbox_group apex-item-group apex-item-group--rc apex-item-checkbox" role="group">'+
                    '<div class="apex-item-grid checkbox_group">'+
                    '<div class="apex-item-grid-row">'+
                    vTemp + 
                    '</div>'+
                    '</div>'+
                    '</div>'/*+
                    '</div></div>'+
                    '</div>'*/;
            /*for (var i = 0; i < params.item.options.length; i++) {
                vChecked = '';
                for (var j = 0; j < vValueArr.length; j++) {
                    if (vValueArr[j] == params.item.options[i].r) vChecked = ' checked="checked"';
                }
                vTemp += '<div><input type="checkbox" id="' + params.id + '_' + i + '" value="' + params.item.options[i].r
                    + '"' + vChecked + ' /><label>' + params.item.options[i].d + '</label></div>';
            }
            vTemp = '<div class="lxFormChk" id="' + params.id + '">' + vTemp + '</div>';*/
            break;
        default: null;
    }
    //return '<div class="' + (params.item.class ? params.item.class : 'lxFormItem') + '"><label>' + params.item.label + '</label>' + vTemp + '</div>';
	//alert(params.classResp);
    return  '<div class="col ' + (params.classResp ? params.classResp : '') + 
            '"><div class="t-Form-fieldContainer t-Form-fieldContainer--stacked apex-item-wrapper'+ wrapperType +'">'+
            '<div class="t-Form-labelContainer"><label class="t-Form-label">' + params.item.label + '</label></div>' + 
            '<div class="t-Form-inputContainer"><div class="t-Form-itemWrapper">'+ vTemp +'</div></div>'+ 
            '</div></div>';
};

lx.item.val = function (params) {
    var vValue;
    switch (params.type) {
        case "H": vValue = $v(params.id); break;
        case "N": vValue = $v(params.id); break;
        case "T": vValue = $v(params.id); break;
        case "TA": vValue = $v(params.id); break;
        case "D": vValue = $v(params.id); break;
        case "S": vValue = $v(params.id); break;
        case "C": vValue = $v(params.id); break;
            /*var checkboxValues = [];
            $("#" + params.id + " > input:checked").map(function () { checkboxValues.push($(this).val()); });
            vValue = checkboxValues.join(':');
            break;*/
        default: vValue = "";
    }
    return vValue;
};

lx.region.gen = function (options){
    var lRet = '';
    // Header - title and buttons
    lRet = '<div class="t-Region-headerItems t-Region-headerItems--title"><h2 class="t-Region-title">'+ options.title +'</h2></div>';
    lRet += '<div class="t-Region-headerItems t-Region-headerItems--buttons">'+ lx.btn.genAll( options.btns ) +
            '</div>';
    lRet = '<div class="t-Region-header">'+ lRet +
            '</div>';
    // content
    lRet += '<div class="t-Region-bodyWrap">'+
            '<div class="t-Region-body">'+
            '<div class="container'+ (options.contentClass ? ' '+options.contentClass : '') +'"'+ 
                (options.contentId ? ' id="'+options.contentId +'"' : '') +
                '>'+ options.content +'</div>'+
            '</div>'+
            '</div>';
    // return HTML
    return  '<div class="t-Region t-Region--scrollBody t-Form--stretchInputs t-Form--labelsAbove"'+
            (options.id ? ' id="'+ options.id +'"' : '')+
            '>'+ lRet +
            '</div>';
};

lx.item.setFeatureVal = function(pRecId, pValue, pCode) {
    var lValue = 'N';
    if (pValue == true) {lValue = 'Y'}
	if (pCode == 'PRJ') {
		if ($('input[name="PRJ"]:checked').length > 0) {
				$('input[name="PATT"]').prop("checked", true);
				$('input[name="PRJ_HOURS"]').prop("checked", true);
		} 
		if ($('input[name="PRJ"]:checked').length == 0) {
				$('input[name="PATT"]').prop("checked", false);
				$('input[name="PRJ_HOURS"]').prop("checked", false);
				$('input[name="PATT"]').prop("disabled", true);
				$('input[name="PRJ_HOURS"]').prop("disabled", true);
		} 
	}	
	if (pCode == 'TS' || pCode == 'OHRS' || pCode == 'VR') {
		if ($('input[name="TS"]:checked').length == 0 && $('input[name="OHRS"]:checked').length == 0 && $('input[name="VR"]:checked').length == 0) {
			$('input[name="ROOSTER"]').prop("checked", false);
		} else {
			$('input[name="ROOSTER"]').prop("checked", true);
		}
	}	
	
    $.ajax({
        url: "wwv_flow.show",
        dataType: "text",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=setFeatureVal",
            x01: pRecId,
            x02: lValue
        },
        success: function (d) {apex.submit("REFRESH");}
    });
};

lx.item.featureCalculateFlag = false;
lx.item.featureCalculate = function () {
    // avoiding recursion (onchange)
    if (lx.item.featureCalculateFlag) return
    else lx.item.featureCalculateFlag = true;
    // number format
    const nFormat = new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'});
    // number of checked modules
    let modules = $(".features .group .feature.pay input:checked").length - 1;
    $("#moduleNo").val( modules );
    $("#moduleNoD").text( modules );
    // number of emps
    let empNo = Math.floor( lx.util.vn("empNo") );
    let empNoMin = document.getElementById('empNo').dataset.min;
    if (empNo < empNoMin) empNo = empNoMin;
    $s('empNo', empNo);
    $("#empNoD").text(empNo);
    // hide show plural
    /*if (empNo == 1) $("#empPlural").hide();
    else $("#empPlural").show();*/
    // module * emp total
    let modPrice = parseFloat(document.getElementById('empNo').dataset.price);
    let moduleEmpPrice = modPrice * modules * empNo;
    $("#empTotal").text( nFormat.format(moduleEmpPrice) );
    // Disk units
    let diskUnits = Math.floor( lx.util.vn("diskUnits") );
    let diskUnitsMin = document.getElementById('diskUnits').dataset.min;
    if (diskUnits < diskUnitsMin) diskUnits = diskUnitsMin;
    $s('diskUnits', diskUnits);
    $("#diskUnitsD").text(diskUnits);
    $("#totalGb").text( (50*diskUnits) );
    // hide show plural
    /*if (diskUnits == 1) $("#diskPlural").hide();
    else $("#diskPlural").show();*/
    // disk total
    let diskPrice = parseFloat(document.getElementById('diskUnits').dataset.price);
    let diskTotal = diskUnits * diskPrice;
    $("#diskTotal").text( nFormat.format(diskTotal) );
    // Owner price
    let ownerPrice = parseFloat(document.getElementById('profileOwner').dataset.price);
    // Total
    $("#total").text( nFormat.format(moduleEmpPrice + diskTotal + ownerPrice, true) );

    if (empNo > 40) {
        $(".btnCont.enterprise").show();
        $(".btnCont.free,.public .total").hide();
    } else {
        $(".btnCont.enterprise").hide();
        $(".btnCont.free,.public .total").show();
    }

    lx.item.featureCalculateFlag = false;
}

lx.item.featureCheckParent = function (pThis) {
    //console.log(pThis);
    if (pThis.dataset.module == 'Y') {
        //console.log('module');
        let l_module_paid = false;
        if (pThis.dataset.features == 0){
            l_module_paid = pThis.checked && pThis.dataset.free == 'N';
            //console.log('single feature');
        } else {
            $(pThis).closest(".group").find(".subGroup .subFeature input").each(function () {
                if (this.checked && this.dataset.free == 'N') {
                    l_module_paid = true;
                }
            });
            //console.log('multiple features');
        }
        //console.log(l_module_paid);
        if (l_module_paid) {
            $(pThis).closest(".feature").addClass('pay');
            pThis.dataset.paid = 'Y';
        } else {
            $(pThis).closest(".feature").removeClass('pay');
            pThis.dataset.paid = 'N';
        }
        lx.item.featureCalculate();
    }
}

lx.item.setFeature = function (pThis, pMode) {
    let val = (pThis.checked ? 'Y' : 'N');
    let fId = pThis.value;
    if (pMode){
        // dont check parents (stops infinite loop)
        null;//console.log(fId +' > '+ val);
    } else if (pThis.dataset.parent) {
        // check parent if not checked
        let par = pThis.dataset.parent;
        let $par = $(".features input[value="+ par +"]");
        let parChecked = $par.is(":checked");
        let childChecked = $("input[data-parent="+ par +"]:checked").val();
        if (!childChecked && parChecked)
            $(".features input[value="+ par +"]").each( function () { this.checked = false; lx.item.setFeature(this, 1)} );
        else if (childChecked != "" && !parChecked)
            $(".features input[value="+ par +"]").each( function () { this.checked = true; lx.item.setFeature(this, 1)} );
        
    } else {
        // check all features in module
        if (val == 'Y') $(pThis).closest('.group').find(".subGroup input:not(:checked)").each( function () { this.checked = true; lx.item.setFeature(this, 1)} );
        else $(pThis).closest('.group').find(".subGroup input:checked").each( function () { this.checked = false; lx.item.setFeature(this, 1)} );
    }
    // check features required for this feature
    if (val == 'Y' && pThis.dataset.reqlist){
        let req = pThis.dataset.reqlist.split(':');
        req.forEach(el => {
            $(".features input[data-code="+ el +"]:not(:checked)").each( function() {
                this.checked = true;
                lx.item.setFeature(this);
            });
        });
    }
    // check if this feature is required for another feature
    if (val == 'N') {
        $(".features input[data-reqlist*="+ pThis.dataset.code +"]:checked").each( function() {
            this.checked = false;
            lx.item.setFeature(this);
        });
    }
    let isPublic = $(".features").hasClass("public");
    if (isPublic) {
        if (pThis.dataset.module == 'Y') lx.item.featureCheckParent(pThis);
        else lx.item.featureCheckParent( $(pThis).closest(".group").find(".feature input").get(0) );
    } else {
        apex.server.process("setFeatureVal", {
            x01: fId,
            x02: val
        }, {
            dataType: "json",
            success: function(d) {
                //console.log(d)
                if (d.success) {
                    if (pThis.dataset.module == 'Y') lx.item.featureCheckParent(pThis);
                    else lx.item.featureCheckParent( $(pThis).closest(".group").find(".feature input").get(0) );
                } else {
                    console.log(d.err);
                }
            }
        });
    }
}

lx.item.toggleFeature = function (pThis) {
    let $i = $(pThis);
    $i.toggleClass("fawe-chevron-up");
    $i.closest(".group").find(".subGroup").toggle();
}

lx.item.setPriv = function(pThis, pCheckOnly) {
    let checked = pThis.checked;
    let edit = pThis.dataset.right == 'E';
    let $priv = $(pThis).closest(".priv");
    //console.log($priv);
    let id = $priv[0].dataset.id;
    //console.log(id);
    if (!pCheckOnly) lx.btn.hightlight("lxSave");
    // handle read/edit dependancy
    if (edit && checked) {
        //console.log($priv.find("input[data-right=R]")[0]);
        $priv.find("input[data-right=R]").each(function(){
            this.checked = true;
        });
    } else if (!edit && !checked) {
        //console.log($priv.find("input[data-right=E]")[0]);
        $priv.find("input[data-right=E]").each(function(){
            this.checked = false;
        });
    }
    // child privileges
    $priv.closest(".privs").find(".priv[data-parent="+ id +"]").each(function(){
        if (checked) {
            $(this).show();
        } else {
            // hide and uncheck
            $(this).hide().find("input").each(function(){
                this.checked = false;
            });
        }
    });
}

/*02.10.2024 - MC - This function should be deleted when new Settings becomes official*/
lx.item.submitPrivOld = function () {
    let groupId = $(".features")[0].dataset.group;
    let ids = [];
    let rights = [];
    let codes = [];

    $(".features .privs .priv").each(function () {
        let id = this.dataset.id;
        let right = 'N';
        // check edit priv
        $(this).find("input[data-right=E]").each(function () {
            if (this.checked) right = 'E';
        });
        // check read priv only if edit not checked
        if (right == 'N')  $(this).find("input[data-right=R]").each(function () {
                                if (this.checked) right = 'R';
                            });
        // push change if checked
        if (right != 'N') {
            ids.push(id);
            rights.push(right);
            codes.push(this.dataset.code+"-"+right);
        }
    });
    console.log(codes);
    
    apex.server.process("submitPriv", {
        x01: groupId,
        x02: $v("P365_GROUP_NAME"),
        x03: $v("P365_DESCRIPTION"),
        f01: ids,
        f02: rights
    }, {
        dataType: "json",
        success: function(d) {
            if (d.err) {
                console.log(d.err);
            } else {
                apex.message.showPageSuccess(d.msg);
				lx.btn.unhightlight("lxSave");
                if (!groupId) $("#features")[0].dataset.group = d.id;
            }
        }
    });
}

lx.item.submitPriv = function () {
    let groupId = $(".features")[0].dataset.group;
    let ids = [];
    let rights = [];
    let codes = [];

    $(".features .privs .priv").each(function () {
        let id = this.dataset.id;
        let right = 'N';
        // check edit priv
        $(this).find("input[data-right=E]").each(function () {
            if (this.checked) right = 'E';
        });
        // check read priv only if edit not checked
        if (right == 'N')  $(this).find("input[data-right=R]").each(function () {
                                if (this.checked) right = 'R';
                            });
        // push change if checked
        if (right != 'N') {
            ids.push(id);
            rights.push(right);
            codes.push(this.dataset.code+"-"+right);
        }
    });
    console.log(codes);
    
    apex.server.process("submitPriv", {
        x01: groupId,
        x02: $v("P363_GROUP_NAME"),
        x03: $v("P363_DESCRIPTION"),
        f01: ids,
        f02: rights
    }, {
        dataType: "json",
        success: function(d) {
            if (d.err) {
                console.log(d.err);
            } else {
                apex.message.showPageSuccess(d.msg);
				lx.btn.unhightlight("lxSave");
                if (!groupId) $("#features")[0].dataset.group = d.id;
            }
        }
    });
}

lx.item.textareaLength = function(val, code, maxVal) {
    if (val == 0) {
        var len = $("#" + code + "_TEXT").val().length;
    } else {
        var len = val.value.length;
    }
    if (len > maxVal) {
        val.value = val.value.substring(0, maxVal);
    } else {
        if (len > 0) {
            $("#" + code + "_CC").remove();
            $('<div class="textarea-counter" id="' + code + '_CC"></div>').insertAfter("#" + code + "_TEXT");
            $("#" + code + "_CC").html(len + " of " + maxVal);
        } else {
            $("#" + code + "_CC").remove();
        }
    }
};

var closeHelpHandler = function (event) {
    if (!$(event.target).closest('.lxItemHelpHint').length) {
        $('.lxItemHelpHint').hide();
        $(document).off("click", "html", closeHelpHandler);
    }
};

 
lx.item.helpbutton = function (pType, pItem, pContent){
    if (pType =='R') {
    vTitle = $('#'+pItem +'_heading').text();
    vButton = '<button class="t-Form-helpButton js-itemHelp" title="Help Text: '+vTitle +'" tabindex="-1" type="button" onclick="lx.item.help(\''+pType+'\',\''+pItem +'\',\''+vTitle +'\',\''+pContent +'\');"><span class="a-Icon icon-help" aria-hidden="true"></span></button>';
    $('#'+pItem +'_heading').replaceWith(vButton +'&nbsp;' +vTitle);
 } 
}		
/* ex getHelp function*/
lx.item.help = function(pType, pItem, pTitle, pContent) {
    console.log(pType +' '+pItem +' ' +pTitle);
    $("#lxHelpDialog").remove();
    var dialogId = 'lxHelpDialog';
    var vPg = $v('pFlowStepId');
    var vItem = pItem;
   
    if (pItem === undefined) {
        vItem = ""
    }

    apex.server.process("getHelp", {
        x01: pType,
        x02: vPg,
        x03: vItem
    }, {
        dataType: "html",
        success: function(r) {
            var dialogDiv = '<div id="' + dialogId + '">' + r + '</div>';
            var vHelp = pContent;
			if (pContent == "undefined") {vHelp = pTitle}
            $(dialogDiv).dialog({
                modal: true,
                resizable: false,
                title: vHelp,
                minWidth: 300,
                minHeight: 200
            });
        }
    });
};

lx.item.showDropdown = function (element) {
    var event;
    event = document.createEvent('MouseEvents');
    event.initMouseEvent('mousedown', true, true, window);
    element.dispatchEvent(event);
};

// TODO cleanup after we ditch the old app
var getLxItemVal = lx.item.val;
var getChbxVal = lx.item.getChbxVal;
var refresh_item = lx.item.refresh_item;
var setFeatureVal = lx.item.setFeatureVal;
var textareaLength = lx.item.textareaLength;
var getHelp = lx.item.help;